import { GET, getUrl } from 'src/services/ApiService';

const FeaturesService = () => {
  const apiUrl = () => getUrl('home', '/features');

  const getFeatures = async () => {
    return await GET(`${apiUrl()}/`, true);
  };

  const getAllFeatures = async () => {
    return GET(`${apiUrl()}/all`);
  };

  return {
    getFeatures,
    getAllFeatures
  };
};

export default FeaturesService();
